import { Profile } from 'stores/types/Profiles';

export const shouldAskForLocationUpdate = (
  petProfile: Profile,
): boolean => !petProfile.location?.locality;
